import { render, staticRenderFns } from "./YourPolicyContent.vue?vue&type=template&id=205e2a26&scoped=true&"
import script from "./YourPolicyContent.vue?vue&type=script&lang=js&"
export * from "./YourPolicyContent.vue?vue&type=script&lang=js&"
import style0 from "./YourPolicyContent.vue?vue&type=style&index=0&id=205e2a26&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "205e2a26",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VDivider})
